import { render, staticRenderFns } from "./BannerNotifications.vue?vue&type=template&id=0cf11496&scoped=true"
import script from "./BannerNotifications.vue?vue&type=script&lang=js"
export * from "./BannerNotifications.vue?vue&type=script&lang=js"
import style0 from "./BannerNotifications.vue?vue&type=style&index=0&id=0cf11496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf11496",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBanner,VBtn,VContainer,VIcon})
